// extracted by mini-css-extract-plugin
export var deleteModal = "_io-0";